module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "assessoria"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Assessoria")])], 1), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('bloquinho', {
    staticClass: "-responsive --grey-hover"
  }, [_c('i', {
    staticClass: "proad proad-estatistica",
    attrs: {
      "slot": "icone"
    },
    slot: "icone"
  }), _c('template', {
    slot: "sigla"
  }, [_vm._v("ASTEC")]), _c('p', {
    attrs: {
      "slot": "texto"
    },
    slot: "texto"
  }, [_vm._v("À ASTEC compete auxiliar o Pró-Reitor de Administração na gestão da informação orçamentária e demais atribuições.")])], 2)], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154a7f68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Assessoria.vue
// module id = 456
// module chunks = 0